import { render, staticRenderFns } from "./ordershipment.vue?vue&type=template&id=6b8dbaba&scoped=true"
import script from "./ordershipment.vue?vue&type=script&lang=js"
export * from "./ordershipment.vue?vue&type=script&lang=js"
import style0 from "./ordershipment.vue?vue&type=style&index=0&id=6b8dbaba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8dbaba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8dbaba')) {
      api.createRecord('6b8dbaba', component.options)
    } else {
      api.reload('6b8dbaba', component.options)
    }
    module.hot.accept("./ordershipment.vue?vue&type=template&id=6b8dbaba&scoped=true", function () {
      api.rerender('6b8dbaba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/ordershipment.vue"
export default component.exports